import React from 'react';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Separator,
  Button,
} from '@lb-classroom/ui';
import { X } from 'lucide-react';
import RadioInputs from '@components/UI/atoms/form/RadioInputs';
import ModalMessage from '@components/UI/organisms/ModalMessage';
import type { AddShiftSetModalProps } from './add-shift-set-modal.types';

export const AddShiftSetModal = ({
  duplicateOptions,
  selectedSetId,
  message,
  messageType,
  onSetIdChange,
  onSubmit,
  onClose,
}: AddShiftSetModalProps) => {
  const radioProps = {
    options: duplicateOptions,
    className: '',
    id: 'select-issue-type',
    value: selectedSetId,
    name: 'set-to-duplicate-select',
    updateHandler: onSetIdChange,
    invalidLabel: true,
    onKeyDown: onSubmit,
  };

  return (
    <div className="max-w-lg mx-auto">
      <Card className="z-50">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle>Add New Shift Set</CardTitle>
          <button type="button" className="modal-close" onClick={onClose}>
            <span className="sr-only">Close</span>
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </CardHeader>
        <CardContent>
          <ModalMessage message={message} messageType={messageType} />
          <form
            method="post"
            className="report-and-resolve-issue-form"
            onSubmit={onSubmit}
            noValidate
          >
            <div>
              <div className="issue-type-wrapper mb-4">
                <h5>Choose a shift set to duplicate</h5>
                <RadioInputs {...radioProps} />
              </div>
            </div>
            <Separator className="my-4" />
            <div className="text-right">
              <Button size="lg" type="submit">
                Create
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
